export interface ContactPhone {
  label?: string;
  number: string;
  displayNumber: string;
}

export interface ContactChannel {
  id: string;
  title: string;
  description: string;
  phones: ContactPhone[];
}

export interface ServiceHours {
  weekdays: string;
  weekendsAndHolidays: string;
  timezoneNote: string;
}

export const WHATSAPP_GREEN = "#25D366";
export const WHATSAPP_GREEN_LIGHT = "#E8F5E9";
export const CARD_BORDER_COLOR = "#F0F0F0";

export const WHATSAPP_BASE_URL = "https://wa.me/";

export const SERVICE_HOURS: ServiceHours = {
  weekdays: "Seg a Sex: 7h às 20h",
  weekendsAndHolidays: "Sábados e feriados: 8h às 12h",
  timezoneNote: "Horário de Brasília",
};

export const CONTACT_CHANNELS: ContactChannel[] = [
  {
    id: "central-atendimento",
    title: "Central de Atendimento",
    description: "Dúvidas gerais e suporte",
    phones: [
      {
        number: "5592985317011",
        displayNumber: "(92) 98531-7011",
      },
    ],
  },

  {
    id: "cobranca",
    title: "Central de Cobrança",
    description: "Faturas e negociação",
    phones: [
      { number: "5592985291543", displayNumber: "(92) 98529-1543" },
      { number: "5592985300787", displayNumber: "(92) 98530-0787" },
    ],
  },
];
